export default __webpack_public_path__ + "static/media/piggyBank.8c64eb7e.svg";